export default "__VITE_ASSET__gQDaMOaz__"